import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=09a135c3"
import script from "./Teacher.vue?vue&type=script&lang=js"
export * from "./Teacher.vue?vue&type=script&lang=js"
import style0 from "./Teacher.vue?vue&type=style&index=0&id=09a135c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports